import OfertaEmprendedores from "@/config/brands/ofertaEmprendedores";

describe("OfertaEmprendedores config", () => {
  it("configuracion exportada por defecto", () => {
    expect(OfertaEmprendedores).toBeDefined();
    expect(OfertaEmprendedores).not.toBeNull();
  });
});
